import React from 'react'
import { withTranslation } from 'react-i18next';

const Stedsnavn = (props) => {
    var stedsnavn = props.stedsnavn;
    return(
        <li className="resultitem" onClick={() => props.onSelectResult(stedsnavn)}>
            <div className="title">{stedsnavn.stedsnavn} ({props.t('stedsnavn')})</div>
            <div>{props.t('kommune')}: {stedsnavn.kommunenavn}</div>
        </li>
    )
  }

export default withTranslation('common')(Stedsnavn)